// Static SEO data for the top 25 highest-search Indian cities for legal help.
// Powers /legal-help/lawyer-in-:citySlug (see pages/CityLawyerGuide.jsx).
// Facts here are general public-knowledge court/jurisdiction information —
// no case-specific or promotional claims are made.

const slp = (highCourt) =>
  `An appeal from a final or interlocutory order of the ${highCourt} can be carried to the Supreme Court of India by way of a Special Leave Petition (SLP) under Article 136 of the Constitution. An SLP must ordinarily be filed within 90 days of the High Court's judgment (or 60 days for certain certified-copy-pending cases), and must be drafted, settled and filed by an Advocate-on-Record registered with the Supreme Court.`;

export const CITY_GUIDES = [
  {
    slug: "delhi",
    city: "Delhi",
    state: "Delhi (NCT)",
    highCourt: "Delhi High Court",
    districtCourt: "Delhi District Courts (Tis Hazari, Patiala House, Saket, Rohini, Dwarka & Karkardooma)",
    dlsaInfo: "The Delhi State Legal Services Authority (DSLSA) runs 11 District Legal Services Authorities across Delhi, offering free legal aid and mediation to eligible litigants from Patiala House Courts.",
    slpNote: slp("Delhi High Court"),
  },
  {
    slug: "noida",
    city: "Noida",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court (seated at Prayagraj)",
    districtCourt: "Gautam Buddh Nagar District & Sessions Court, Surajpur",
    dlsaInfo: "The District Legal Services Authority, Gautam Buddh Nagar (DLSA Noida) provides free legal aid, lok adalats and mediation services at the Surajpur District Court complex.",
    slpNote: slp("Allahabad High Court"),
  },
  {
    slug: "ghaziabad",
    city: "Ghaziabad",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court (seated at Prayagraj)",
    districtCourt: "Ghaziabad District & Sessions Court, Kavi Nagar",
    dlsaInfo: "The District Legal Services Authority, Ghaziabad (DLSA Ghaziabad) offers free legal aid and lok adalat facilitation at the Kavi Nagar district court complex.",
    slpNote: slp("Allahabad High Court"),
  },
  {
    slug: "gurugram",
    city: "Gurugram",
    state: "Haryana",
    highCourt: "Punjab and Haryana High Court, Chandigarh",
    districtCourt: "Gurugram District & Sessions Court, Sector 51",
    dlsaInfo: "The District Legal Services Authority, Gurugram (DLSA Gurugram) provides free legal aid, especially to homebuyers and employees, with regular lok adalats.",
    slpNote: slp("Punjab and Haryana High Court"),
  },
  {
    slug: "faridabad",
    city: "Faridabad",
    state: "Haryana",
    highCourt: "Punjab and Haryana High Court, Chandigarh",
    districtCourt: "Faridabad District & Sessions Court, Sector 12",
    dlsaInfo: "The District Legal Services Authority, Faridabad (DLSA Faridabad) runs free legal aid clinics and lok adalats for eligible litigants.",
    slpNote: slp("Punjab and Haryana High Court"),
  },
  {
    slug: "lucknow",
    city: "Lucknow",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court, Lucknow Bench",
    districtCourt: "Lucknow District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Lucknow (DLSA Lucknow) offers free legal aid and mediation referrals at the district court complex.",
    slpNote: slp("Allahabad High Court, Lucknow Bench"),
  },
  {
    slug: "prayagraj",
    city: "Prayagraj",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court (principal seat)",
    districtCourt: "Prayagraj (Allahabad) District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Prayagraj (DLSA Prayagraj) provides free legal aid near the principal seat of the Allahabad High Court.",
    slpNote: slp("Allahabad High Court"),
  },
  {
    slug: "kanpur",
    city: "Kanpur",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court (seated at Prayagraj)",
    districtCourt: "Kanpur Nagar District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Kanpur Nagar (DLSA Kanpur) offers free legal aid and lok adalats for eligible litigants.",
    slpNote: slp("Allahabad High Court"),
  },
  {
    slug: "varanasi",
    city: "Varanasi",
    state: "Uttar Pradesh",
    highCourt: "Allahabad High Court (seated at Prayagraj)",
    districtCourt: "Varanasi District & Sessions Court, Cantt",
    dlsaInfo: "The District Legal Services Authority, Varanasi (DLSA Varanasi) provides free legal aid and mediation facilities at the Cantt district court complex.",
    slpNote: slp("Allahabad High Court"),
  },
  {
    slug: "mumbai",
    city: "Mumbai",
    state: "Maharashtra",
    highCourt: "Bombay High Court",
    districtCourt: "Mumbai City Civil & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Mumbai City/Suburban provides free legal aid, lok adalats and mediation referrals under the Maharashtra State Legal Services Authority.",
    slpNote: slp("Bombay High Court"),
  },
  {
    slug: "pune",
    city: "Pune",
    state: "Maharashtra",
    highCourt: "Bombay High Court",
    districtCourt: "Pune District & Sessions Court, Shivajinagar",
    dlsaInfo: "The District Legal Services Authority, Pune offers free legal aid clinics and lok adalats at the Shivajinagar district court complex.",
    slpNote: slp("Bombay High Court"),
  },
  {
    slug: "nagpur",
    city: "Nagpur",
    state: "Maharashtra",
    highCourt: "Bombay High Court, Nagpur Bench",
    districtCourt: "Nagpur District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Nagpur provides free legal aid and mediation services near the Nagpur Bench of the Bombay High Court.",
    slpNote: slp("Bombay High Court, Nagpur Bench"),
  },
  {
    slug: "bengaluru",
    city: "Bengaluru",
    state: "Karnataka",
    highCourt: "Karnataka High Court",
    districtCourt: "Bengaluru City Civil & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Bengaluru Urban offers free legal aid, lok adalats and mediation referrals for eligible litigants.",
    slpNote: slp("Karnataka High Court"),
  },
  {
    slug: "chennai",
    city: "Chennai",
    state: "Tamil Nadu",
    highCourt: "Madras High Court",
    districtCourt: "Chennai City Civil Court",
    dlsaInfo: "The District Legal Services Authority, Chennai provides free legal aid and lok adalat facilitation under the Tamil Nadu State Legal Services Authority.",
    slpNote: slp("Madras High Court"),
  },
  {
    slug: "hyderabad",
    city: "Hyderabad",
    state: "Telangana",
    highCourt: "Telangana High Court",
    districtCourt: "City Civil Court, Hyderabad",
    dlsaInfo: "The District Legal Services Authority, Hyderabad offers free legal aid and mediation referrals near the Telangana High Court.",
    slpNote: slp("Telangana High Court"),
  },
  {
    slug: "kolkata",
    city: "Kolkata",
    state: "West Bengal",
    highCourt: "Calcutta High Court",
    districtCourt: "City Civil Court, Kolkata (Alipore)",
    dlsaInfo: "The District Legal Services Authority, Kolkata provides free legal aid, lok adalats and mediation services at the Alipore court complex.",
    slpNote: slp("Calcutta High Court"),
  },
  {
    slug: "patna",
    city: "Patna",
    state: "Bihar",
    highCourt: "Patna High Court",
    districtCourt: "Patna Civil Court",
    dlsaInfo: "The District Legal Services Authority, Patna offers free legal aid and lok adalats near the Patna High Court and Patna Civil Court.",
    slpNote: slp("Patna High Court"),
  },
  {
    slug: "ranchi",
    city: "Ranchi",
    state: "Jharkhand",
    highCourt: "Jharkhand High Court",
    districtCourt: "Ranchi Civil Court",
    dlsaInfo: "The District Legal Services Authority, Ranchi provides free legal aid and mediation referrals for eligible litigants.",
    slpNote: slp("Jharkhand High Court"),
  },
  {
    slug: "jaipur",
    city: "Jaipur",
    state: "Rajasthan",
    highCourt: "Rajasthan High Court, Jaipur Bench",
    districtCourt: "Jaipur District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Jaipur offers free legal aid, lok adalats and mediation services near the Jaipur Bench of the Rajasthan High Court.",
    slpNote: slp("Rajasthan High Court, Jaipur Bench"),
  },
  {
    slug: "jodhpur",
    city: "Jodhpur",
    state: "Rajasthan",
    highCourt: "Rajasthan High Court (principal seat)",
    districtCourt: "Jodhpur District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Jodhpur provides free legal aid near the principal seat of the Rajasthan High Court.",
    slpNote: slp("Rajasthan High Court"),
  },
  {
    slug: "ahmedabad",
    city: "Ahmedabad",
    state: "Gujarat",
    highCourt: "Gujarat High Court",
    districtCourt: "Ahmedabad City Civil & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Ahmedabad offers free legal aid, lok adalats and mediation referrals under the Gujarat State Legal Services Authority.",
    slpNote: slp("Gujarat High Court"),
  },
  {
    slug: "surat",
    city: "Surat",
    state: "Gujarat",
    highCourt: "Gujarat High Court",
    districtCourt: "Surat District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Surat provides free legal aid and mediation services for eligible litigants.",
    slpNote: slp("Gujarat High Court"),
  },
  {
    slug: "chandigarh",
    city: "Chandigarh",
    state: "Chandigarh (UT)",
    highCourt: "Punjab and Haryana High Court",
    districtCourt: "District Court, Sector 43, Chandigarh",
    dlsaInfo: "The District Legal Services Authority, Chandigarh offers free legal aid, lok adalats and mediation services near the Punjab and Haryana High Court.",
    slpNote: slp("Punjab and Haryana High Court"),
  },
  {
    slug: "bhopal",
    city: "Bhopal",
    state: "Madhya Pradesh",
    highCourt: "Madhya Pradesh High Court (principal seat at Jabalpur)",
    districtCourt: "Bhopal District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Bhopal provides free legal aid and lok adalats for litigants in the state capital.",
    slpNote: slp("Madhya Pradesh High Court"),
  },
  {
    slug: "dehradun",
    city: "Dehradun",
    state: "Uttarakhand",
    highCourt: "Uttarakhand High Court, Nainital",
    districtCourt: "Dehradun District & Sessions Court",
    dlsaInfo: "The District Legal Services Authority, Dehradun offers free legal aid and mediation referrals near the state capital.",
    slpNote: slp("Uttarakhand High Court"),
  },
];

export const getCityGuide = (slug) => CITY_GUIDES.find((c) => c.slug === (slug || "").toLowerCase());
